import SocialAccounts from "./SocialAccounts";

export default SocialAccounts;
